import React from "react";
import tronImage  from "../../../../assets/tron_live.png"
const About = () => {
  return (
    <div className="ss-trade_frontpage_wrapper" id="home">
    <div className="container">
      <div className="ss-trade_front_hero_section">
        <div className="ss-trade_front_hero_img">
          <img src={tronImage} width="1200px" height="800px" alt="heroimage" />
        </div>
        <div className="ss-trade_front_hero_content">
          <h2 style={{fontSize:"100px"}}>SST PRO</h2>
        </div>
      </div>
    </div>
    {/* <div class="skew_divider"></div> */}
  </div>
  );
};

export default About;
